/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import clsx from 'clsx';
import customStyles from "../../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { AreaTable } from "./AreaTable";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { Row, Col, Image, Space } from "antd";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Button, TextField, Box, Autocomplete } from "@mui/material";
import Down from "../../../../Shared/components/Icons/Down";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import MainHeader from "../../../../Shared/components/Header";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import { toast } from 'react-toastify';
import usePrevious from "../../../../Shared/components/Previous";
import { NavLink } from "react-router-dom";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { emptyValidation } from "../../../../../helpers/validation";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const Area = (props) => {
    const { cityDetails, pincodeDetails, countryDetails, stateDetails, areaDetails, areaLoader } = useSelector(state => state.addressReducer);
    const { createDetails, createError, createLoader, getList, getData } = useSelector(state => state.crudReducer);
    const [visible, setVisible] = useState(false);
    const [areaName, setAreaName] = useState('');
    const [pincodeId, setPincodeId] = useState('');
    const [cityId, setCityId] = useState('');
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [stateId, setStateId] = useState('');
    const [countryId, setCountryId] = useState('');

    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);

    const [errorAreaName, setErrorAreaName] = useState(false);
    const [errorPincodeId, setErrorPincodeId] = useState(false);
    const [errorCityId, setErrorCityId] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const [cityData, setCityData] = useState([]);
    const [pincodeData, setPincodeData] = useState([]);
    const [filterData, setfilterData] = useState({});
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const type = 'import';
    const [importVisible, setImportVisible] = useState(false);
    const searchInput = useRef(null);
    const { roleManagement } = useSelector(state => state.authReducer);
    const {  moduleType } = props;

    const handleOpenImport = () => {
        setImportVisible(true);
    }

    const onExport = () => {
        loadImportExportData('Area');
    }

    const handleImportClose = () => {
        setImportVisible(false);
    }

    const handleOpen = () => {
        emptyState();
        emptyStateInput();
        setVisible(true);
    };

    const emptyState = () => {
        setErrorAreaName(false);
        setErrorPincodeId(false);
        setErrorCityId(false);
    }

    const emptyStateInput = () => {
        setAreaName('');
        setCityId('');
        setStateId('');
        setCountryId('');
        setCityData([]);
        setPincodeData([]);
    }

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const dispatch = useDispatch();

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder, filterData);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder, filterData);
                }, 500);
            }
        }
    }, [search]);


    useEffect(() => {
        if (roleManagement !== '') {
            // if (checkViewPermission('Area', history, 'Younote Admin')) {
            loadTasks();
            //  }
        }
        return () => {
            dispatch({
                type: actions.CLEAR_ADDRESS_DETAILS_START,
            });
        };
    }, [roleManagement]);

    useEffect(() => {
        setCityData(cityDetails);
        setPincodeData(pincodeDetails);
    }, [cityDetails]);

    useEffect(() => {
        setPincodeData(pincodeDetails);
    }, [pincodeDetails]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, filterData, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        if (search !== '') {
            filter['and'].push({ name: { like: '%' + search.trim() + '%' } });
        }

        if (filterData) {
            if (filterData?.cityId && filterData?.cityId !== '') {
                filter['and'].push({ cityId: filterData?.cityId });
            }
            if (filterData?.stateId && filterData?.stateId !== '') {
                filter['and'].push({ stateId: filterData?.stateId });
            }
            if (filterData?.pincodeId && filterData?.pincodeId !== '') {
                filter['and'].push({ pincodeId: filterData?.pincodeId });
            }
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'areas',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            },

        });
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: actions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: actions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id desc'
            }
        });
        dispatchFilter(sortBy, sortOrder, filterData);
    });

    const createPincode = (e) => {
        e.preventDefault();
        let emptyAreaName = emptyValidation('Area Name', areaName);
        let emptyPincodeId = emptyValidation('Pincode', pincodeId, 'dropDown');
        let emptyCityId = emptyValidation('City', cityId, 'dropDown');
        emptyState();
        if (emptyAreaName.isValid && emptyCityId.isValid && emptyPincodeId.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'area',
                title: "Area",
                details: {
                    name: areaName,
                    pincodeId: pincodeId,
                    cityId: cityId,
                    stateId: stateId,
                    countryId: countryId
                }
            });
        } else {
            if (emptyAreaName.errors !== '') {
                setErrorAreaName(emptyAreaName.errors);
            }
            if (emptyCityId.errors !== '') {
                setErrorCityId(emptyCityId.errors);
            }
            if (emptyPincodeId.errors !== '') {
                setErrorPincodeId(emptyPincodeId.errors);
            }
        }
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["and"]: [] };
        if (search !== '') {
            filter['and'].push({ name: { like: '%' + search.trim() + '%' } });
        }
        if (filterData) {
            if (filterData?.cityId && filterData?.cityId !== '') {
                filter['and'].push({ cityId: filterData?.cityId });
            }
            if (filterData?.stateId && filterData?.stateId !== '') {
                filter['and'].push({ stateId: filterData?.stateId });
            }
            if (filterData?.pincodeId && filterData?.pincodeId !== '') {
                filter['and'].push({ pincodeId: filterData?.pincodeId });
            }
        }
        dispatch({
            type: actions.AREA_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'areas',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder, filterData);
            setVisible(false);
            toast(createDetails);
            emptyStateInput();
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setErrorAreaName(error);
        }
    }, [createDetails, createError]);


    const changeCity = (value) => {
        setCityId(value);
        let a = cityDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setStateId(a[0].stateId);
            setCountryId(a[0].countryId);
        }
    }

    const changePincode = (value) => {
        setPincodeId(value);
        let a = pincodeDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCityId(a[0].cityId);
            setStateId(a[0].stateId);
            setCountryId(a[0].countryId);
        }
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder, filterData);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, filterData, s);
    }

    const handleChange = (e) => {
        if (e.target.value === '') {
            handleChangeFilter('', e.target.name)
        }
    }

    const handleChangeFilter = (value, name) => {
        if (value !== '') {
            if (name === 'stateId') {
                setfilterData({
                    [name]: value,
                });
                dispatchFilter(sortBy, sortOrder, {
                    [name]: value
                });
                changeStateApi(value);
            } else if (name === 'cityId') {
                let city = cityDetails && cityDetails.length > 0 ? cityDetails.filter((el) => { return el.id === value }) : [];
                if (city && city.length > 0) {
                    setfilterData({
                        [name]: value,
                        'stateId': city[0]?.stateId
                    });
                    dispatchFilter(sortBy, sortOrder, {
                        [name]: value,
                        'stateId': city[0]?.stateId
                    });
                }
                dispatch({
                    type: actions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                        where: { ["and"]: [{ cityId: value }] }
                    }
                });
            } else {
                let pincode = pincodeDetails && pincodeDetails.length > 0 ? pincodeDetails.filter((el) => { return el.id === value }) : [];
                if (pincode && pincode.length > 0) {
                    setfilterData({
                        [name]: value,
                        'stateId': pincode[0]?.stateId,
                        'cityId': pincode[0]?.cityId
                    });
                    dispatchFilter(sortBy, sortOrder, {
                        [name]: value,
                        'stateId': pincode[0]?.stateId,
                        'cityId': pincode[0]?.cityId
                    });
                }
            }
        } else {
            if (name === 'stateId') {
                setCityData([]);
                setPincodeData([]);
                setfilterData({
                    ...filterData,
                    [name]: value,
                    'cityId': '',
                    'pincodeId': ''
                });
                dispatchFilter(sortBy, sortOrder, {
                    ...filterData,
                    [name]: value,
                    'cityId': '',
                    'pincodeId': ''
                });
            } else if (name === 'cityId') {
                if (filterData?.stateId && filterData?.stateId !== '') {
                    dispatch({
                        type: actions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                            where: { ["and"]: [{ stateId: filterData?.stateId }] }
                        }
                    });
                } else {
                    setPincodeData([]);
                }
                setfilterData({
                    ...filterData,
                    [name]: value,
                    'pincodeId': ''
                });
                dispatchFilter(sortBy, sortOrder, {
                    ...filterData,
                    [name]: value,
                    'pincodeId': ''
                });
            } else {
                setfilterData({
                    ...filterData,
                    [name]: value
                });
                dispatchFilter(sortBy, sortOrder, {
                    ...filterData,
                    [name]: value
                });
            }
        }
    }

    const changeStateApi = (value) => {
        dispatch({
            type: actions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
        dispatch({
            type: actions.CITY_DETAILS_START, url: 'city', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
    }

    const handleStateFieldChange = (id) => {
        setStateId(id);
        changeStateApi(id);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={moduleType !== undefined ? moduleType : 'Younote Admin'}
                links={[{ 'label': moduleType !== undefined ? moduleType : 'Younote Admin', 'link': moduleType === 'Admin' ? '/admin' : '/younote-admin' },
                { 'label': 'Address Management', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Area'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Area', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                // onChange={(e) => setPassword(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.vertiCalScrollOverFlowParent)}>
                                <div className={classes.vertiCalScrollOverFlow}>
                                    <Space size={[20, 20]} direction="horizontal" align="center">
                                        <Autocomplete
                                            className={clsx(classes.customAutocomplete, classes.customAutocompleteBorder, classes.width150)}
                                            popupIcon={<Down />}
                                            fullWidth
                                            forcePopupIcon={"auto"}
                                            clearOnEscape
                                            onClose={() => {
                                                searchInput?.current?.blur();
                                            }}
                                            disableClearable
                                            getOptionLabel={(option) => option.name ? option.name : ""}
                                            options={stateDetails ? stateDetails : []}
                                            classes={{ paper: classes.dropdownStyle }}
                                            value={stateDetails && customObject(stateDetails, filterData?.stateId, 'state') ? customObject(stateDetails, filterData?.stateId, 'state') : []}
                                            onChange={(event, newValue) => {
                                                if (typeof newValue === 'object' && newValue !== null) {
                                                    handleChangeFilter(newValue.id, 'stateId') // help to set the value
                                                } else {
                                                    handleChangeFilter('', 'stateId') // help to reset the value
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField autoComplete='one-time-code'
                                                    inputRef={searchInput}
                                                    name={'stateId'}
                                                    onChange={(e) => handleChange(e)}
                                                    {...params}
                                                    label='All State'
                                                    variant="standard"
                                                />
                                            )}
                                        />
                                        {
                                            filterData?.stateId && <Autocomplete
                                                className={clsx(classes.customAutocomplete, classes.customAutocompleteBorder, classes.width150)}
                                                popupIcon={<Down />}
                                                fullWidth
                                                forcePopupIcon={"auto"}
                                                clearOnEscape
                                                onClose={() => {
                                                    searchInput?.current?.blur();
                                                }}
                                                disableClearable
                                                getOptionLabel={(option) => option.name ? option.name : ""}
                                                options={cityData ? cityData : []}
                                                classes={{ paper: classes.dropdownStyle }}
                                                value={cityData && customObject(cityData, filterData?.cityId, 'city') ? customObject(cityData, filterData?.cityId, 'city') : []}
                                                onChange={(event, newValue) => {
                                                    if (typeof newValue === 'object' && newValue !== null) {
                                                        handleChangeFilter(newValue.id, 'cityId') // help to set the value
                                                    } else {
                                                        handleChangeFilter('', 'cityId') // help to reset the value
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField autoComplete='one-time-code'
                                                        inputRef={searchInput}
                                                        onChange={(e) => handleChange(e)}
                                                        {...params}
                                                        name={'cityId'}
                                                        label='All City'
                                                        variant="standard"
                                                    />
                                                )}
                                            />
                                        }
                                        {
                                            filterData?.cityId && <Autocomplete
                                                className={clsx(classes.customAutocomplete, classes.customAutocompleteBorder, classes.width150)}
                                                popupIcon={<Down />}
                                                fullWidth
                                                forcePopupIcon={"auto"}
                                                clearOnEscape
                                                onClose={() => {
                                                    searchInput?.current?.blur();
                                                }}
                                                disableClearable
                                                getOptionLabel={(option) => option.code ? option.code : ""}
                                                getOptionSelected={(option, value) => option.code === value.code}
                                                options={pincodeData ? pincodeData : []}
                                                classes={{ paper: classes.dropdownStyle }}
                                                value={pincodeData && customObject(pincodeData, filterData?.pincodeId, 'pincodeId') ? customObject(pincodeData, filterData?.pincodeId, 'pincodeId') : []}
                                                onChange={(event, newValue) => {
                                                    if (typeof newValue === 'object' && newValue !== null) {
                                                        handleChangeFilter(newValue.id, 'pincodeId') // help to set the value
                                                    } else {
                                                        handleChangeFilter('', 'pincodeId') // help to reset the value
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField autoComplete='one-time-code'
                                                        inputRef={searchInput}
                                                        onChange={(e) => handleChange(e)}
                                                        {...params}
                                                        name={'pincodeId'}
                                                        label='All Pincode'
                                                        variant="standard"
                                                    />
                                                )}
                                            />
                                        }

                                        {
                                            roleManagement !== '' && checkComponentPermission('Area', 'Action', 'Export') &&
                                            <NavLink to="#"
                                                onClick={() => onExport()}
                                                className={clsx(classes.customLink)}>
                                                <Image
                                                    src={ExportIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                            </NavLink>
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission('Area', 'Action', 'Import') &&
                                            <NavLink
                                                to="#"
                                                onClick={() => handleOpenImport()}
                                                className={clsx(classes.customLink)}>
                                                <Image
                                                    src={ImportIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                            </NavLink>
                                        }
                                        {
                                            roleManagement !== '' && (checkCRUDPermission('Area', 'create', 'Younote Admin') || checkCRUDPermission('Area', 'create', 'Admin')) &&
                                            <NavLink
                                                to="#"
                                                onClick={() => handleOpen()}
                                                className={clsx(classes.customLink, classes.disInline, classes.cursor)}>
                                                <Image
                                                    src={AddIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add</span>
                                            </NavLink>
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission('Area', 'Action', 'Filter') &&
                                            <></>
                                        }
                                    </Space>
                                    </div>
                                </Col>
                            </Row>
                            <AreaTable
                                loadTasks={() => dispatchFilter(sortBy, sortOrder, filterData)}
                                cityDetails={cityData}
                                moduleType={moduleType}
                                countryDetails={countryDetails}
                                stateDetails={stateDetails}
                                pincodeDetails={pincodeData}
                                details={getList}
                                loadMore={loadMore}
                                changeStateApi={(id) => changeStateApi(id)}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                customObject={(details, id) => customObject(details, id)}
                                roleManagement={roleManagement}
                                sortOrder={sortOrder} sortBy={sortBy} onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={'Add Area'}
                    width={"360px"}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createPincode(e)}
                        >
                            <div className={classes.customFormFlex}>
                                <TextField autoComplete='one-time-code'
                                    label={["Area Name ", <span key={"Area Name"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorAreaName ? true : false}
                                    helperText={errorAreaName}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setAreaName(e.target.value)}
                                />
                                <AutoCompleteComponent
                                    name={["State"]}
                                    heads={[{ 'key': 'name', 'name': 'State Name' },
                                    { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                    details={stateDetails}
                                    parentValue={customObject(stateDetails, stateId)}
                                    onChange={(data) => handleStateFieldChange(data.id)}
                                    position={'bottom'}
                                    customClasses={classes.margin20t}
                                />
                                <AutoCompleteComponent
                                    name={["Pincode ", <span key={"Pincode"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'code', 'name': 'Pincode' },
                                    { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                    details={pincodeData ? pincodeData : []}
                                    parentValue={customObject(pincodeData, pincodeId)}
                                    onChange={(data) => changePincode(data.id)}
                                    position={'bottom'}
                                    customClasses={classes.margin20t}
                                    parentError={errorPincodeId}
                                />
                                <AutoCompleteComponent
                                    name={["Dist/City/Town ", <span key={"Dist/City/Town"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Name' },
                                    { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                    details={cityData ? cityData : []}
                                    parentValue={customObject(cityData, cityId)}
                                    onChange={(data) => changeCity(data.id)}
                                    position={'bottom'}
                                    customClasses={classes.margin20t}
                                    parentError={errorCityId}
                                />
                                <AutoCompleteComponent
                                    name={["Country"]}
                                    heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                    details={countryDetails}
                                    parentValue={customObject(countryDetails, countryId)}
                                    onChange={(data) => setCountryId(data.id)}
                                    position={'bottom'}
                                    customClasses={classes.margin20t}
                                />
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Button
                                    key="add"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}>Save</Button>
                            </div>
                        </Box>
                    }
                />
                <ImportExport
                    handleClose={() => handleImportClose()}
                    visible={importVisible}
                    title={'Area'}
                    type={type}
                    details={areaDetails}
                    loader={areaLoader}
                    loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                    loadTasks={() => { dispatchFilter(sortBy, sortOrder, filterData) }}
                />
            </div>
        </React.Fragment >
    )
}

export default Area